<studio-dialog>
  <studio-dialog-title text="Collect Digital DNA"></studio-dialog-title>
  <studio-dialog-description
    text="Save or share unique Digital People blends in their unpublished or published state by collecting their Digital DNA."
  >
  </studio-dialog-description>
  <studio-copiable-text label="Digital DNA" [text]="dna$ | async" [theme]="theme"
    ><studio-form-subtext [theme]="theme"
      >Anyone with this DNA can use it as a starting point to create a
      <b>new Digital Person</b> when loading it via comprehensive mode.</studio-form-subtext
    ></studio-copiable-text
  >

  <studio-dialog-buttons-container>
    <studio-dialog-button
      [theme]="theme"
      text="Done"
      precedence="primary"
      (click)="this.close()"
    ></studio-dialog-button>
  </studio-dialog-buttons-container>
</studio-dialog>
